import { graphql } from '@/gql';
import type { SubmitOrderMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const submitOrder = async ({
  callerId,
  estimate,
  resolveOrderId,
  orderOptions,
  storeGroup,
  skipPriceCheck,
  cardSource,
  isConfirmedSameStoreActiveOrder,
  preferredPhoneNumber,
  clientName,
  isRedelivery,
  originalOrderId,
  natureOfComplaint,
}: SubmitOrderMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      estimate,
      resolveOrderId,
      orderOptions,
      storeGroup,
      skipPriceCheck,
      cardSource,
      isConfirmedSameStoreActiveOrder,
      preferredPhoneNumber,
      clientName,
      isRedelivery,
      originalOrderId,
      natureOfComplaint,
    },
    mutation: graphql(`
      mutation submitOrder(
        $callerId: String!
        $estimate: EstimateInput!
        $orderOptions: OrderOptionsInput!
        $resolveOrderId: String
        $skipPriceCheck: Boolean
        $cardSource: String
        $storeGroup: StoreGroupInput!
        $isConfirmedSameStoreActiveOrder: Boolean
        $preferredPhoneNumber: String
        $clientName: String
        $isRedelivery: Boolean
        $originalOrderId: String
        $natureOfComplaint: String
      ) {
        submitOrder(
          callerId: $callerId
          estimate: $estimate
          orderOptions: $orderOptions
          resolveOrderId: $resolveOrderId
          skipPriceCheck: $skipPriceCheck
          cardSource: $cardSource
          storeGroup: $storeGroup
          isConfirmedSameStoreActiveOrder: $isConfirmedSameStoreActiveOrder
          preferredPhoneNumber: $preferredPhoneNumber
          clientName: $clientName
          isRedelivery: $isRedelivery
          originalOrderId: $originalOrderId
          natureOfComplaint: $natureOfComplaint
        ) {
          id
          preferredPhoneNumber
          clientName
          orderId
          storeOrder {
            service
            orderId
            storeGroup
            title
            subtitle
            estimate {
              items {
                item {
                  title
                  price
                }
              }
              timeEstimate {
                min
                max
              }
              address {
                formattedAddress
              }
            }
          }
        }
      }
    `),
  });

  return response.data?.submitOrder;
};
